module.exports = __webpack_public_path__ + "img/Banner-Plantilla-mediano-1.7f7aac34.png";